<div class="chat-input-container">
  <div class="chat-input-wrapper" [class.disabled]="disabled">
    <textarea
      #textarea
      class="chat-textarea"
      placeholder="Ask about quarterly supply planning or yearly forecasting..."
      [formControl]="prompt"
      (keydown)="handleEnter($event, textarea)"
      [readonly]="disabled"
      rows="1"
      (input)="autoResize(textarea)"
      (blur)="autoResize(textarea)"
    ></textarea>
    
    <button
      class="send-btn"
      [disabled]="disabled || !prompt.value.trim()"
      (click)="submit(textarea)"
      matTooltip="Send message"
    >
      <mat-icon fontIcon="arrow_upward"></mat-icon>
    </button>
  </div>
  <div class="chat-footer">
    AI Agent can make mistakes. Consider checking important information.
  </div>
</div>
